import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { EntryForm, Input } from './EntryForm';
import MediaUploader from './MediaUploader';
import { validations } from '../lib/form';
import { useModalProvider } from '../providers/ModalProvider';
import { isEmpty } from 'lodash';

const EditCategoryForm = ({ 
  category, 
  metadata, 
  onSave, 
  onCancel
 }) => {
  
  const { showModal, closeModal } = useModalProvider();
  
  const formik = useFormik({
    initialValues: {
      name: category?.name || '',
      image_url: category?.image_url || '',
    },
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      name: validations.str_req_20,
      image_url: validations.str_255,
    }),
    onSubmit: (values) => {
      const mediaMetaData = values.media_metadata;
      let fileName;
      if (values.image_url?.includes("media:")) {
        const id = values.image_url.split(":")?.[1];
        fileName = mediaMetaData?.[id]?.filename;
      } else {
        fileName = values.image_url;
      }

      const valueArr = fileName?.split?.(".");
      const extension = valueArr?.[valueArr?.length - 1]?.toLowerCase();
      const imageErrors = {};
      if (values.image_url && extension !== "png") {
        imageErrors.image_url = "Icon must be in .png format";
      }

      if (Object.keys(imageErrors).length > 0) {
        showModal(
          <div className="w-50">
            <h3 className="text-lg font-semibold mb-4">Validation Error</h3>
            <div className="mb-4">
              <ul className="list-disc list-inside space-y-1">
                {Object.entries(imageErrors).map(([field, error]) => (
                  <li key={field}>
                    {error}
                  </li>
                ))}
              </ul>
            </div>
            <div className="flex justify-end">
              <button 
                className="ttnk-button add-button" 
                onClick={(e) => {
                  e.preventDefault();
                  closeModal()
                }}
              >
                Close
              </button>
            </div>
          </div>
        );
        return;
      }

      onSave({
        ...category,
        ...values,
        media_metadata: {
          ...metadata,
          ...values.media_metadata,
        },
      });
    },
  });

  return (
    <div className="w-full" style={{ padding: 30 }}>
      <h1 className="ttnk-page__title uppercase m-0">
        Edit Custom Category
      </h1>
      <EntryForm formik={formik} submitHandler={formik.handleSubmit} cancelHandler={onCancel} removeStyle={true}>
        <div className='flex-1 mt-4 px-4' >
          <div className="mb-5">
            <Input
              name="name"
              type="text"
              label="Category Label"
              formik={formik}
              required
            />
          </div>

          <div className="mb-5">
            <MediaUploader
              name="image_url"
              label="Icon"
              formik={formik}
              metadata={metadata}
              mediaType="image"
            />
            <div className="italic text-sm text-right font-medium -mt-3">
              Must be .png format. 
              <br/>
              White icon on a clear background is ideal
              <br />
              Must be 512x512 pixel size.
            </div>
          </div>
        </div>
      </EntryForm>
    </div>
  );
};

export default EditCategoryForm;